/** Every custom-field type the product supports. */
export const FIELD_TYPES = {
  address: "address",
  checkbox: "checkbox",
  date: "date",
  dateTime: "dateTime",
  select: "select",
  email: "email",
  files: "files",
  member: "member",
  money: "money",
  number: "number",
  paragraph: "paragraph",
  phone: "phone",
  photos: "photos",
  region: "region",
  text: "text",
  time: "time",
  url: "url",
} as const;

export type FieldType = keyof typeof FIELD_TYPES;
